export default "__VITE_ASSET__9cf44cda__"